import axios from "axios";
import customerAxiosInstance from "../api/customerAxiosInstance";

const DEFAULT_PROMO_ERROR = 'There was an error applying your discount code, please try again later';

export const sendPromoValidationRequest = async ({ promoCode, apiUrl, apiAccessToken, brand, env, customer }) => {
    try {
        // For logged-in users
        if (customer && customer.accessToken && customer.accessToken.customer?.id) {
            const customerAxios = customerAxiosInstance({
                apiUrl,
                brand,
                env,
                customerData: {
                    accessToken: customer.accessToken.accessToken,
                    refreshToken: customer.accessToken.refreshToken,
                    apiAccessToken: apiAccessToken,
                },
            });

            const customerId = customer.accessToken.customer.id;
            return await customerAxios.get(`/jp/promotional-discounts?channel=web&promoCode=${promoCode}&customerId=${customerId}`);
        } else {
            // For guest uesrs
            return await axios.get(`${apiUrl}/jp/promotional-discounts?channel=web&promoCode=${promoCode}`, {
                headers: {
                    'X-Access-Token': apiAccessToken,
                }
            });
        }
    } catch (e) {
        return {
            data: {
                errors: [
                    new Error(DEFAULT_PROMO_ERROR)
                ]
            }
        }
    }
}
